import { Box, Button, Flex, IconFont } from '@byecode/ui'
import styled from 'styled-components'

export const SelectContainer = styled.div`
    width: 100%;
`

export const Description: typeof Box = styled(Box)`
    color: var(--color-gray-400);
    font-size: var(--font-size-sm);
    font-weight: 400;
    line-height: 18px;
`

export const Container = styled.div``

export const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`

export const ButtonContent = styled(Button)`
    line-height: 20px;
`

export const Icon = styled(IconFont)`
    margin-right: 6px;
`

export const Close = styled(IconFont)`
    cursor: pointer;
    color: var(--color-gray-600);
    &:hover {
        color: var(--color-gray-800);
    }
`

export const ButtonContainer = styled.div`
    margin: 4px 0;
`

export const ListItem = styled(Flex)`
    height: 40px;
`

export const Tag = styled.div`
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
    color: var(--color-black);
`

export const ErrorTag = styled.span`
    padding: 2px 4px;
    line-height: 24px;
    color: var(--color-red-500);
    background-color: var(--color-red-100);
    border-radius: 4px;
    font-size: 14px;
    overflow: hidden;
`
